import { isNumeric } from "rxjs/util/isNumeric";
import { UserContext, TipoUtente } from "./_models/user-context";
import { FormArray } from "@angular/forms";
import { saveAs } from 'file-saver/FileSaver';
import { DataContext } from "./_models/data-context";

export class Utils {

  static getRedirectHomepage() {
    if (this.isUtenteSmistatore()) {
      return '/spedizione';
    } else if (this.isUtenteProduttore()) {
      return '/produzione';
    } else if (this.isUtenteAmministratore() || this.isUtenteRichiedente()) {
      return '/';
    } else {
      return '/login';
    }
  }

  static isUserLogged(): boolean {
    if (sessionStorage.getItem('ArubaProvisioningWebFrontEnd:currentUser')) {
      // logged in so return true
      return true;
    }

    return false;
  }

  static getUserContext(): UserContext {
    const uctx = JSON.parse(sessionStorage.getItem('ArubaProvisioningWebFrontEnd:currentUser')) as UserContext;

    return uctx;
  }

  static setUserContext(utx: UserContext) {
    sessionStorage.setItem('ArubaProvisioningWebFrontEnd:currentUser', JSON.stringify(utx));
  }

  static removeUserContext() {
    sessionStorage.removeItem('ArubaProvisioningWebFrontEnd:currentUser');

    this.removeDataContext();
  }

  static getDataContext(): DataContext {
    let uctx = this.getUserContext();
    if (uctx == null) {
      this.removeDataContext();
      return null;
    }
    const dctx = JSON.parse(sessionStorage.getItem('ArubaProvisioningWebFrontEnd:currentData')) as DataContext;

    return dctx;
  }

  static setDataContext(dtx: DataContext) {
    sessionStorage.setItem('ArubaProvisioningWebFrontEnd:currentData', JSON.stringify(dtx));
  }

  static removeDataContext() {
    sessionStorage.removeItem('ArubaProvisioningWebFrontEnd:currentData');
  }

  static cloneObject(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }

  static convertNumber2String(data: number): string {
    if (data == null || data == Number.MIN_VALUE || data == Number.NEGATIVE_INFINITY)
      return null;

    return '' + data;
  }

  static convertString2Number(data: string): number {
    if (data == null || data == '')
      return null;

    if (isNumeric(data))
      return +data;

    return null;
  }

  static isUtenteAmministratore() {
    let utx = this.getUserContext();

    if (!utx) return false;

    return utx.tipoUtente == TipoUtente.Amministratore;
  }

  static isUtenteProduttore() {
    let utx = this.getUserContext();

    if (!utx) return false;

    return utx.tipoUtente == TipoUtente.Produttore;
  }

  static isUtenteRichiedente() {
    let utx = this.getUserContext();

    if (!utx) return false;

    return utx.tipoUtente == TipoUtente.Richiedente;
  }

  static isUtenteSmistatore() {
    let utx = this.getUserContext();

    if (!utx) return false;

    return utx.tipoUtente == TipoUtente.Smistatore;
  }

  static convertDateYMD2DMYString(date: any): string {
    if (date == null || date == '')
      return null;

    // in : yyyy-mm-dd
    // out: dd-mm-yyyy

    let day = ''
    let month = ''
    let year = ''

    if (date instanceof Date) {
      day = '' + date.getDate();
      month = '' + (date.getMonth() + 1);
      year = '' + date.getFullYear();
    }
    else {
      let fields = date.split('-');
      if (fields.length != 3)
        return '';

      day = '' + fields[2];
      month = '' + fields[1];
      year = '' + fields[0];
    }
    if (day.length < 2)
      day = '0' + day;
    if (month.length < 2)
      month = '0' + month;

    return day + '-' + month + '-' + year;
  }

  static convertDateDMY2YMDString(date: any): string {

    if (date == null || date == '')
      return null;

    // in : dd-mm-yyyy
    // out: yyyy-mm-dd

    let day = ''
    let month = ''
    let year = ''

    if (date instanceof Date) {
      day = '' + date.getDate();
      month = '' + (date.getMonth() + 1);
      year = '' + date.getFullYear();
    }
    else {
      let fields = date.split('-');
      if (fields.length != 3)
        return '';

      day = '' + fields[0];
      month = '' + fields[1];
      year = '' + fields[2];
    }

    if (day.length < 2)
      day = '0' + day;
    if (month.length < 2)
      month = '0' + month;

    return year + '-' + month + '-' + day;
  }

  static getFilenameExtension(fname: string): string {
    return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
  }

  static getEncodedFilename(fname: string): string {
    // La codifica standard di XmlHttpRequest è UTF-8
    // eventuali codifiche sono fatte lato server
    //    return encodeURIComponent(fname);

    return fname;
  }

  static getDecodedFilename(fname: string): string {
    // La codifica standard di XmlHttpRequest è UTF-8
    // eventuali codifiche sono fatte lato server
    // return decodeURIComponent(fname);

    return fname;
  }

  static clearFormArray(formArray: FormArray) {
    if (formArray == null)
      return;

    while (formArray.controls.length > 0)
      formArray.removeAt(0);

    formArray.markAsTouched();
  }

  static removeFromFormArray(formArray: FormArray, idx: number) {
    formArray.removeAt(idx);

    // La rimozione programmatica non modifica il valore di 'touched'
    // -> lo faccio io, così possono essere verificati i risultati dei validatori
    formArray.markAsTouched();
  }

  static saveToFileSystem(response, filenameFallback = 'file.dat') {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    let filename = parts[1].split('=')[1];
    while (filename.length > 0 && filename[0] == '"') {
      filename = filename.substr(1);
    }
    while (filename.length > 0 && filename[filename.length - 1] == '"') {
      filename = filename.substr(0, filename.length - 1);
    }
    if (filename == '') {
      filename = filenameFallback;
      console.error('Impossibile determinare il nome del file')
    }

    const blob = new Blob([response.body], { type: response.body.type });
    saveAs(blob, filename);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils.ts